import React from 'react'
import style from './FeaturedBlock.module.css'
import {
  featured1, featured2, featured3, featured4, featured5,
} from '../../../Assets/Images/Roofing/Featured'

const featuredImages = [
    { src: featured5, alt: 'featured_2' },
    { src: featured4, alt: 'featured_3' },
    { src: featured3, alt: 'featured_4' },
    { src: featured2, alt: 'featured_5' },
]

const FeaturedBlock = () => (
    <div className={style.featured}>
        <div className="customContainer">
            <div className={style.titles}>
                <hr className={style.titles_line} />
                <h2 className={style.titles_title}>Featured Project</h2>
                <hr className={style.titles_line} />
            </div>

            <div className={style.wrap}>
                <img
                    src={featured1}
                    alt="Featured Main"
                    className={style.wrap_mainImg}
                />
                <div className={style.wrap_right}>
                    <div className={style.textContent}>
                        <h4 className={style.title}>Dudley St.</h4>
                        <p className={style.description}>
                            The Dudley St project in Narberth, Pennsylvania is a standout example of high-end exterior construction and custom craftsmanship. This residence features a carefully executed copper roof and shingle exterior combination, with precise detailing at every transition, edge, and reveal to achieve a clean and cohesive architectural finish. The warmth of the copper roofing complements the shingle siding, creating depth, contrast, and a timeless aesthetic that will continue to improve as the materials naturally age. The project required extensive planning, custom fabrication, and an exceptional level of attention to detail. The finished result is a visually striking exterior that reflects our expertise in premium materials, complex exterior systems, and luxury residential construction.
                        </p>
                    </div>
                    <div className={style.imagesWrap}>
                        {featuredImages.map(({ src, alt }) => (
                            <img
                                key={alt}
                                src={src}
                                alt={alt}
                                className={style.imagesWrap_img}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export default FeaturedBlock
